/**
 * Order Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  clearOrderAction,
  getAllOrderItemsAction,
  getOrderWithIdAction,
  updateOrderStatusActions,
  getLogsAction,
  getCatAction,
} from '../orders/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
  makeSelectAllOrderItems,
  makeSelectLogs,
  makeSelectCatList,
} from '../orders/selectors';

import Client from 'client-sdk/src/client';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Radio,
  RadioGroup,
  Select,
  FormControl,
  FormControlLabel,
  Card,
  CardHeader,
  CardContent,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
  Divider,
  DialogActions,
  Button,
  TextareaAutosize,
  MenuItem,
  Input,
  FormHelperText,
  Chip,
} from '@material-ui/core';

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  Autocomplete,
} from '@material-ui/lab';

// Icon
import Icon from '@mdi/react';
import {
  mdiPencilOutline,
  mdiClose,
  mdiPackageVariant,
  mdiDotsHorizontalCircleOutline,
  mdiPackageVariantClosed,
  mdiTruckFastOutline,
  mdiMapMarkerCheckOutline,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDownOutline,
  mdiClipboardCheckOutline,
  mdiPlusBoxMultipleOutline,
  mdiAccountArrowRight,
  mdiStoreOutline,
  mdiCashMultiple,
  mdiChevronLeft,
  mdiReceipt,
  mdiPrinter,
  mdiLabel,
  mdiCircleMedium,
  mdiChat,
  mdiChatOutline,
} from '@mdi/js';

// Components
import ListOrderItems from './list';
import InventoryItemsList from './inventoryItemsList';
import Can from '../../components/Can';
import showOrderTplType from '../../utils/temporaryConditions/showOrderTplType';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../utils/rulesOrderStatus';

// Helper
import { translate, formaterPhoneNumber } from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type

import { Status, Log } from '../orders/interfaces';
import { SelectorProps, Props } from './interfaces';
import CSV from './csv';
import { getInventoryItemsWithSerialAction } from '../parcels/actions';
import { makeSelectInventoryItemsWithSerialList } from '../parcels/selectors';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleNotfication from '../../utils/handleNotfication.tsx';
import handleError from '../../utils/handleError';
import Modal from '../../components/Modal';
import classes from './index.module.scss';
import windowSize from '../../utils/hook/useWindowResize';
import DetailsMobile from './mobileView';
import { DialogTitle } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import AxiosClient from 'client-sdk/src/client';
import {
  FileUploadTicketsRequestBuilder,
  PostAllTicketsRequestBuilder,
} from 'client-sdk/src/helpical/categories';
import Bell from '../../components/Notification/Bell';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import { RonadDropzone } from '../../components/RonadDropzone';
import getAllCategories from '../../requests/getAllCategories';
import getAllDepartments from '../../requests/getAllDepartments';
import getAllTickets from '../../components/Notification/getAllTickets';
import TicketLink from '../../components/ticketLink';
import showDeliveryType from '../../utils/temporaryConditions/showDeliveryType';

const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته‌بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  BUNDLED: mdiPackageVariantClosed, //' بسته‌بندی شده برای راننده',
  CANCELLED: mdiClose, //'لغو شده',
  DELIVERED_TO_POST: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED_TO_CENTER: mdiDotsHorizontalCircleOutline, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: mdiDotsHorizontalCircleOutline, //'تامین در مرکز',
  PACKAGED: mdiPackageVariant, //'بسته‌بندی شده برای مشتری',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  LOADED: mdiTruckFastOutline, // 'در حال تحویل',
  NOT_DELIVERED: mdiClipboardAlertOutline, //'تحویل داده نشده',
  ORDERED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  RETURNED: mdiClipboardArrowDownOutline, //'بازگردانده شده',
  PICKED: mdiPlusBoxMultipleOutline, //'برداشته شده',
  ASSIGNED: mdiAccountArrowRight, //'برداشته شده',
};

const ticketPriority = [
  {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
];
const ticketType = [
  {
    id: 0,
    name: 'ORDER',
    title: 'سفارش',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'PARCEL',
    title: 'محموله',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  {
    id: 2,
    name: 'NONE',
    title: 'هیچکدام',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
];

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [isTapin, setIsTapin] = useState<boolean>(false);
  const [tapinBarcode, setTapinBarcode] = useState<number | undefined>();
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openInventoryItems, setOpenInventoryItems] = useState(
    false as boolean
  );
  const [postTrackingCode, setPostTrackingCode] = useState<null | string>(null);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();
  const [openMsg, setOpenMsg] = useState(false);
  const [file, setFile] = useState<any>('');
  const { register, control, errors, handleSubmit, setValue, getValues, watch } =
    useForm({
      defaultValues: {
        type: "ORDER",
        file: null,
        title: null,
        priority: '',
        subject: '',
        msg: '',
        category: '',
        "parcel-order-number": (props.match.params.id ? props.match.params.id : ''),
      },
    });
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token') || '';

  const [depts, setDepts] = useState<any[]>([
    { "id": 51, "name": "عملیات و انبار", "helpicalId": 11 },
    { "id": 52, "name": "ارسال و سفارشات", "helpicalId": 12 },
    { "id": 53, "name": "مالی", "helpicalId": 13 },
    { "id": 54, "name": "فنی", "helpicalId": 14 }
  ]);
  const [activeDepartment, setActiveDepartment] = useState<string | null | undefined>(null);
  const [categories, setCategories] = useState<any[]>([]);
  const [hasTickets, setHasTickets] = useState<boolean>(false);
  const [activeCategory, setCategory] = useState<number | null | undefined>(undefined);

  useEffect(() => {
    getAllTickets({
      "orderId.equals": props.match.params.id,
    }).then(response => {
      if (response.data.length > 0) {
        setHasTickets(true);
      } else {
        setHasTickets(false);
      }
    })
  }, []);

  const getTapinBarcode = async id => {
    try {
      const response = await ordersRepository.getOrderTapinBarcode({
        payload: {
          ids: id,
        },
      });
      const myResponse = response.data.barcodes[0]?.barcode[0];
      if (myResponse) {
        setTapinBarcode(myResponse);
        setIsTapin(true);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const handleCloseModal = () => {
    setOpenMsg(false);
    setFile(null);
    // console.log("IN CLOSE MODAL");
    setValue('file', null);
    setCategories([]);
    setCategory(null);
    setValue('category', '');
    setActiveDepartment(undefined);
  };

  const handleShowInventoryItems = (data: any) => {
    props.getInventoryItems({
      orderItemId: { equals: data.id },
      callback: () => setOpenInventoryItems(true),
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };
  const history = useHistory();

  useEffect(() => {
    const { id } = props.match.params;
    getTapinBarcode(id);
    props.orderWithIdActionDispatch(id);
    props.getOrderItemsActionDispatch({
      'orderId.equals': id,
      page: 0,
      size: 1000,
    });
  }, []);

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  useEffect(() => {
    props.getLogsDispatch(props.match.params.id);
    if (props.order?.postTrackingCode) {
      setPostTrackingCode(props.order?.postTrackingCode);
    }
  }, [props.order]);

  useEffect(() => {
    return () => {
      props.clearOrderActionDispatch();
    };
  }, []);

  const handleChangeFileInput = (event: any) => {
    setFile(event.target.files[0]);
  };

  const onSubmit = async data => {
    try {
      setLoading(true);
      let fileData = new FormData();
      fileData.append('file', file);
      const makeRequest = new PostAllTicketsRequestBuilder()
        .params({})
        .data({
          orderId: props.match.params.id,
          parcelId: null,
          categoryId: activeCategory,
          message: data.msg,
          importance: data.priority,
          subject: data.title,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      if (file) {
        const fileTicketRequest = new FileUploadTicketsRequestBuilder()
          .id(response.data.id)
          .data(fileData)
          .build();
        await client.execute(fileTicketRequest);
      }

      handleNotfication('تیکت با موفقیت ایجاد شدند', 'success');
      history.push(`/orders/${props.match.params.id}`);
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }

      handleError(err.response);
    } finally {
      setFile(null);
      setOpenMsg(false);
      setLoading(false);
      setValue('file', null);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setValue('file', null);
  };

  useEffect(() => {
    if (authContext.user.role !== 'SELLER_ADMIN') {
      try {
        handleActiveDeptChange();
      }
      catch {
        console.log("WHOOPSY!");
      }
    }
  }, [activeDepartment]);



  const handleActiveDeptChange = () => {
    if (activeCategory) {
      setCategory(undefined);
      setValue('category', undefined);
    }
    if (activeDepartment) {
      const response = getAllCategories({
        helpicalDepartmentId: activeDepartment,
      });
      response.then(catResponse => {
        setCategories(catResponse.data);
      });
    }
  };
  // const handleChangeFileInput = (event: any) => {
  //   setFile(event.target.files[0]);
  // };
  //
  const handleFileDropped = (acceptedFile: any) => {
    setFile(acceptedFile);
  };

  {/*isMob ? (
    <DetailsMobile {...props} />
  ) :*/}
  return (
    <div className={classes.root}>
      <Typography variant="h6" component="h1" style={{marginBottom: "24px"}}>
        {`جزئیات سفارش ${props.match.params.id}`}
      </Typography>
      <Grid
        container
        lg={12}
        md={12}
        spacing={4}
        style={{ marginBottom: '32px' }}
      >
        <Grid item lg={3} md={3} sm={12} xs={12}>
          {props.order?.deliveryType === 'COURIER' &&
            props.order?.orderTPLType === 'CHAPAR' && (
              <Card className={classes.card}>
                <CardHeader
                  avatar={
                    <Typography className={classes.typographyCards}>
                      مشخصات مرسوله چاپار
                    </Typography>
                  }
                />
                <CardContent style={{ paddingBottom: '10px' }}>
                  <Grid xs={12} sm={12} lg={12} spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <div className={classes.item}>
                        <span className={classes.label}>
                          {'کد رهگیری چاپار:  '}
                        </span>
                        {props.order?.tplTrackingCode && JSON.parse(props.order?.tplTrackingCode).map(
                          (tplTrackCode, index) => {
                            return (
                              <span data-cy={'tplTrackingCode'}>
                                {tplTrackCode}
                              </span>
                            );
                          }
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}
          {isTapin && (
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    مشخصات مرسوله پستی
                  </Typography>
                }
              />

              <CardContent style={{ paddingBottom: '10px' }}>
                <Grid item xs={12} sm={12} spacing={2}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'کد رهگیری پست:  '}</span>

                    <a
                      target="_blank"
                      href={`https://tracking.post.ir/search.aspx?id=${tapinBarcode}`}
                    >
                      <span data-cy="trackingCode">{tapinBarcode}</span>
                    </a>
                  </div>
                </Grid>
              </CardContent>
            </Card>
          )}
          {props.order?.deliveryType !== 'COURIER' && (
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    مشخصات مرسوله پستی
                  </Typography>
                }
              />
              <CardContent style={{ paddingBottom: '10px' }}>
                <Grid xs={12} sm={12} lg={12} spacing={2}>
                  {props.order?.postOrders?.map((order, index) => {
                    return (
                      <>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span style={{ fontSize: '18px' }}>
                              بسته {index + 1}
                            </span>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {'وضعیت مرسوله:  '}
                            </span>
                            <span data-cy={'orderStatus' + index}>
                              {translate(order.orderStatus, 'order')}
                            </span>
                          </div>
                        </Grid>

                        {order.barcode && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'کد رهگیری پست:  '}
                              </span>
                              <a
                                href={`https://tracking.post.ir/search.aspx?id=${order.barcode}`}
                                target="_blank"
                              >
                                <span data-cy={'barcode' + index}>
                                  {order.barcode}
                                </span>
                              </a>
                            </div>
                          </Grid>
                        )}
                        {order.weight && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'وزن پستی (گرم):  '}
                              </span>
                              <span data-cy={'orderWeight' + index}>
                                {order.weight}
                              </span>
                            </div>
                          </Grid>
                        )}
                        {order.totalPrice && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'هزینه پست (ریال):  '}
                              </span>
                              <span data-cy="totalPrice">
                                {order.totalPrice}
                              </span>
                            </div>
                          </Grid>
                        )}
                      </>
                    );
                  })}
                </Grid>
              </CardContent>
            </Card>
          )}
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات سفارش
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '10px' }}>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'وضعیت تحویل:  '}</span>
                  <Can
                    role={authContext.user.role}
                    perform="orders:changeOrderStatus"
                    yes={() => (
                      <FormControl style={{ width: '50%' }}>
                        <Icon
                          path={mdiPencilOutline}
                          size={1}
                          className={classes.changStatusIcon}
                        />
                        <Select
                          className={classes.changStatusBox}
                          fullWidth
                          inputProps={{
                            name: 'name',
                            id: 'uncontrolled-native',
                          }}
                          name={'status'}
                          id={props.order.rubikaId}
                          value={[{}]}
                          IconComponent={() => null}
                          renderValue={() => (
                            <span className={classes.renderValue}>
                              {translate(props.order.status, 'order')}
                            </span>
                          )}
                        >
                          <RadioGroup
                            className={classes.radioGroup}
                            aria-label={'status'}
                            name={'status$'}
                            value={'item'}
                            onChange={(
                              e: React.ChangeEvent<{ value: unknown }>
                            ) =>
                              handleOpenConfirmUpdateState(
                                `"${e.target.value}"` as Status
                              )
                            }
                          >
                            {rulesOrderStatus[props.order.status]?.map(
                              (item: any, index: number) => (
                                <FormControlLabel
                                  className={classes.radioGroupItem}
                                  key={index}
                                  checked={props.order.status === item}
                                  value={item}
                                  disabled={
                                    rulesAdminChangeOrderStatus[
                                      authContext.user.role
                                    ].indexOf(item) === -1
                                  }
                                  control={<Radio />}
                                  label={translate(item, 'order')}
                                />
                              )
                            )}
                          </RadioGroup>
                        </Select>
                      </FormControl>
                    )}
                    no={() => (
                      <span style={{ textAlign: 'left' }} data-cy="status">
                        {translate(props.order.status, 'order')}
                      </span>
                    )}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شیوه پرداخت :  '}</span>

                  <span>{translate(props.order.paymentType, 'cod')}</span>
                </div>
              </Grid>
              {props.order?.paymentType === 'COD' && (
                <Grid item xs={12} sm={12} lg={12} spacing={2}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'مبلغ فاکتور:  '}</span>

                    <span>{props.order.codValue}</span>
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'کدپیگیری:  '}</span>
                  <span data-cy="trackingCode">
                    {props.order?.trackingCode}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'تعداد بسته:  '}</span>
                  <span data-cy="trackingCode">
                    {props.order?.orderPackages?.length}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نوع سفارش:  '}</span>
                  <span data-cy="deliveryType">
                    {/* {translate(props.order?.orderTPLType)} */}
                    {showDeliveryType(props.order.deliveryType)}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'ناوگان حمل:  '}</span>
                  <span data-cy="orderTPLType">
                    {showOrderTplType(props.order.deliveryType, props.order.orderTPLType)}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' تاریخ ثبت سفارش:  '}</span>
                  <span data-cy="registrationDate">
                    {props.order.registrationDate &&
                      `${jMoment(props.order.registrationDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'تاریخ تحویل سفارش:  '}
                  </span>
                  <span data-cy="deliveryDate">
                    {props.order.deliveryDate &&
                      `${jMoment(props.order.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {' بازه تحویل سفارش:  '}
                  </span>
                  <span data-cy="deliveryStartTime">
                    {props.order.deliveryStartTime &&
                      jMoment(props.order.deliveryStartTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                    {' - '}
                    {props.order.deliveryEndTime &&
                      jMoment(props.order.deliveryEndTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                  </span>
                </div>
              </Grid>
              {props.order.description && (
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'توضیحات:  '}</span>
                    <span data-cy="description">
                      {props.order.description && props.order.description}
                    </span>
                  </div>
                </Grid>
              )}
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات سفارش‌دهنده
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '10px' }}>
              <Grid xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نام:   '}</span>

                  <span data-cy="customerName">{props.order.customerName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'کد ملی:'}</span>
                  <span data-cy="customerNationalCode">
                    {props.order?.customerNationalCode}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' شماره ثابت:     '}</span>
                  <span dir="ltr" data-cy="customerPhoneNumber">
                    {props.order?.customerPhoneNumber}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شماره همراه:  '}</span>
                  <span data-cy="customerMobileNumber">
                    {formaterPhoneNumber(props.order.customerMobileNumber)}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' کد پستی:    '}</span>
                  <span data-cy="customerZipCode">
                    {props.order?.customerZipCode}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شهر:  '}</span>

                  <span data-cy="customerCity">
                    {props.order?.customerCity}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'استان:  '}</span>

                  <span data-cy="customerProvince">
                    {props.order?.customerProvince}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.item}>
                  <span className={classes.label} style={{ alignSelf: 'start' }}>
                    {'آدرس:  '}
                  </span>
                  <span
                    style={{ textAlign: 'left', marginRight: '30px' }}
                    data-cy="customerAddress"
                  >
                    {props.order.customerAddress && props.order.customerAddress}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={9} md={9} sm={12} xs={12} spacing={2}>
          <Card className={classes.card} style={{ padding: 0 }}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  لیست کالاهای سفارش {props.order.id}
                </Typography>
              }
              action={
                <Grid item xs={12} style={{ marginTop: '15px' }}>
                  <div style={{ textAlign: 'left', marginBottom: '-20px' }}>
                    {hasTickets && <Link to={`/alltickets/?orderId.equals=${props.match.params.id}`}>
                      <Button
                        style={{ marginLeft: "12px" }}
                        variant="contained"
                        size="large"
                        color="primary"
                      // style={{ marginLeft: '172px' }}
                      >
                        {`سابقه تیکت`}
                      </Button>
                    </Link>}
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      style={{ marginLeft: '12px' }}
                      onClick={() => setOpenMsg(true)}
                    >
                      {`تیکت جدید`}
                    </Button>
                    <Can
                      role={authContext.user.role}
                      perform="orders:downloadReportCSV"
                      yes={() => (
                        <>
                          <CSV
                            // ordersDispatch={props.order}
                            data={props.orderItems}
                            loading={props.loading}
                          />
                        </>
                      )}
                    />
                    {props.order.orderType === 'FROM_CENTER' && (
                      <Can
                        perform="orderExit:print"
                        role={authContext.user.role}
                        yes={() => (
                          <Link
                            to={`/orders/exit-receipts/${props.order.id}`}
                            target="_blank"
                            style={{ textDecoration: 'none', margin: '0px 10px' }}
                          >
                            <Button
                              variant="contained"
                              color="secondary"
                              startIcon={<Icon path={mdiReceipt} size={1} />}
                            >
                              {'چاپ رسید خروج'}
                            </Button>
                          </Link>
                        )}
                      />
                    )}
                    {props.order.receiptUrl &&
                      props.order?.status !== 'CANCELLED' && (
                        <a
                          href={`${props.order.receiptUrl}`}
                          target="_blank"
                          style={{ textDecoration: 'none', marginLeft: '10px' }}
                        >
                          <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Icon path={mdiPrinter} size={1} />}
                          >
                            {'چاپ فاکتور سفارش'}
                          </Button>
                        </a>
                      )}
                    {props.order.fulfillmentAttachmentUrl &&
                      props.order?.status !== 'CANCELLED' && (
                        <a
                          href={`${props.order.fulfillmentAttachmentUrl}`}
                          target="_blank"
                          style={{ textDecoration: 'none' }}
                        >
                          <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<Icon path={mdiLabel} size={1} />}
                          >
                            {'چاپ لیبل های سفارش'}
                          </Button>
                        </a>
                      )}
                  </div>
                </Grid>
              }
            />

            <CardContent
              style={{ margin: '14px 0  0', padding: '0' }}
              className={classes.cardContentList}
            >
              <Grid style={{ width: '100%', margin: '0' }} container spacing={3}>
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : props.order.childOrders?.length > 0 ? (
                  props.order.childOrders.map((childOrder, index) => {
                    return (
                      <React.Fragment>
                        <div>
                          {`لیست کالاهای ${childOrder.fulfillmentWarehouseName}`}
                        </div>
                        <ListOrderItems
                          data={childOrder.items}
                          showItems={data => handleShowInventoryItems(data)}
                        />
                      </React.Fragment>
                    );
                  })
                ) : (
                  props.order?.items && (
                    <>
                      <ListOrderItems
                        data={props.order?.items}
                        showItems={data => handleShowInventoryItems(data)}
                      />
                    </>
                  )
                )}
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card} style={{ marginTop: '24px' }}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  تاریخچه سفارش
                </Typography>
              }
            />
            <CardContent style={{ padding: '0', marginTop: '-10px' }}>
              <Grid container style={{ padding: '0' }}>
                <Grid item xs={12}>
                  <Timeline align="left" style={{ minWidth: '500px' }}>
                    {props.logs
                      ?.slice()
                      .reverse()
                      .map((log: Log, index: number) => (
                        <TimelineItem
                          className={classes.missingOppositeContent}
                          key={index}
                          data-cy="timeLineItem"
                        >
                          <TimelineSeparator>
                            <TimelineDot
                              style={{
                                backgroundColor: colorStatus[log.newStatus],
                                border: index === 0 ? 'solid 4px #DF9234' : '',
                              }}
                            >
                              <Icon path={iconStatus[log.newStatus]} size={1} />
                            </TimelineDot>
                            {index !== props.logs?.length - 1 ? (
                              <TimelineConnector />
                            ) : (
                              ''
                            )}
                          </TimelineSeparator>
                          <TimelineContent className={classes.paperHistory}>
                            <div style={{ padding: '10px' }}>
                              <div className={classes.contentBox}>
                                <div style={{ flex: 2, textAlign: 'right' }}>
                                  <span className={classes.contentlabel}>
                                    وضعیت سفارش:
                                  </span>
                                  <span data-cy="status">
                                    {translate(log.newStatus, 'order')}
                                  </span>
                                  {log.newStatus === 'NOT_DELIVERED' && (
                                    <p data-cy="status">{log.description}</p>
                                  )}
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    textAlign: 'right',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <span className={classes.contentlabel}>
                                    کاربر:
                                  </span>
                                  <Can
                                    role={authContext.user.role}
                                    perform="user-name:dontShowInLogs"
                                    no={() => (
                                      <>
                                        <span>{log.modifierName}</span>
                                        <span>
                                          {' '}
                                          &nbsp; &nbsp;- &nbsp; &nbsp;
                                        </span>
                                      </>
                                    )}
                                  />
                                  <span data-cy="role">
                                    {translate(log.modifierRole, 'user')}
                                  </span>
                                </div>
                                <Typography
                                  component="div"
                                  className={classes.titleBox}
                                  style={{ flex: 1 }}
                                >
                                  {log.time &&
                                    jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                      .locale('fa')
                                      .format('jYYYY/jMM/jDD - HH:mm')}
                                </Typography>
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>


      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
        style={{ padding: '16px' }}
      >
        <DialogTitle>
          <Grid container justifyContent="center" justify="center">
            <p style={{ marginTop: '-8px' }}>ایجاد تیکت جدید</p>
          </Grid>
        </DialogTitle>

        <Grid container direction="column">
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogContent style={{ paddingTop: '0' }}>
              <Grid item md={12} lg={12}>
                <div style={{ marginTop: '2px' }}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    name="title"
                    label="عنوان"
                    error={errors.title}
                    rules={{ required: true, minLength: 4 }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                      ></TextField>
                    }
                  />
                </div>
                {errors.title?.type == "required" && <FormHelperText error focused>
                  عنوان الزامی می‌باشد
                </FormHelperText>}
                {errors.title?.type == "minLength" && <FormHelperText error focused>
                  حداقل 4کاراکتر وارد شود
                </FormHelperText>}
              </Grid>
              <br></br>
              <Grid container direction="row" spacing={2}>
                <Grid item md={4} lg={4}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    id="type"
                    name="type"
                    label="مربوط به"
                    error={errors.type}
                    rules={{ required: false }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                        select
                        disabled
                      >
                        {ticketType.map(item => {
                          return (
                            <MenuItem value={item.name}>
                              {item.title}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    }
                  />
                </Grid>
                <Grid item md={4} lg={4}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    name="parcel-order-number"
                    label="شماره سفارش یا محموله"
                    rules={{ required: watch('type') != "NONE", pattern: /[0-9]/ }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                    }
                  />
                  {errors['parcel-order-number']?.type == "required" && <FormHelperText error focused>
                    شناسه سفارش یا محموله الزامی می‌باشد
                  </FormHelperText>}
                  {errors['parcel-order-number']?.type == "pattern" && <FormHelperText error focused>
                    فقط عدد وارد شود
                  </FormHelperText>}
                </Grid>

                <Grid item md={4} lg={4}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    id="priority"
                    name="priority"
                    label="اولویت"
                    error={errors.priority}
                    rules={{ required: true }}

                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                        select
                      >
                        {ticketPriority.map(item => {
                          return (
                            <MenuItem value={item.name}>
                              <Chip
                                icon={
                                  <Icon
                                    path={mdiCircleMedium}
                                    size={1}
                                    color={item.color}
                                  />
                                }
                                label={item.title}
                                style={{
                                  color: item.color,
                                  backgroundColor: item.bcolor,
                                  fontSize: '16px',
                                }}
                              />
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    }
                  />
                  <FormHelperText error focused>
                    {errors.priority &&
                      "اولویت الزامی می‌باشد"
                    }

                  </FormHelperText>

                </Grid>
              </Grid>

              <Grid container direction="row" spacing={2}>
                <Grid item md={6} lg={6}>
                  <Autocomplete
                    id="department"
                    options={depts}
                    getOptionLabel={option => option.name}
                    disableClearable={true}
                    onChange={(e: any, newValue: any | null | undefined) => {
                      if (newValue) {
                        setActiveDepartment(newValue.helpicalId);
                        // console.log(
                        //   'changing active department to',
                        //   newValue,
                        //   'helpicalId: ',
                        //   newValue.helpicalId
                        // );
                        // handleActiveDeptChange();
                      } else if (newValue === '') {
                        // console.log('active dept is not found');
                      }
                    }}
                    renderInput={params => (
                      <TextField
                        name="department"
                        inputRef={register({ required: true })}
                        {...params}
                        label="دسته‌بندی"
                        fullWidth
                        variant="outlined"
                      />
                    )}
                  />
                  <FormHelperText error focused>
                    {errors.department &&
                      'دسته‌بندی الزامی میباشد'}
                  </FormHelperText>
                </Grid>

                <Grid item md={6} lg={6}>
                  <Autocomplete
                    id="category"
                    options={categories}
                    disabled={!activeDepartment}
                    onChange={(event: any, newValue: any | null) => {
                      setCategory(newValue.id);
                    }}
                    getOptionLabel={option => option?.name}
                    disableClearable={true}
                    renderInput={params => (
                      <TextField
                        fullWidth
                        {...params}
                        inputRef={register({ required: true })}
                        label="موضوع"
                        variant="outlined"
                        name="category"
                      />
                    )}
                  />
                  <FormHelperText error focused>
                    {errors.category &&
                      'موضوع الزامی میباشد'}
                  </FormHelperText>



                </Grid>
              </Grid>
              <Controller
                control={control}
                id="msg"
                name="msg"
                rules={{ required: true }}
                error={errors.msg}
                as={
                  <TextField
                    inputProps={{
                      style: {
                        minHeight: '120px',
                        maxHeight: '240px',
                        padding: '0 8px',
                      },
                    }}
                    margin="normal"
                    multiline
                    label="متن پیام"
                    variant="outlined"
                    fullWidth
                  />
                }
              />

              <FormHelperText error focused>
                {errors.msg &&
                  "متن پیام الزامی است"
                }

              </FormHelperText>


              <Grid container direction="row" spacing={2}>
                <Grid item md={12} lg={12}>
                  <RonadDropzone
                    register={register}
                    onDropped={handleFileDropped}
                  />
                </Grid>
              </Grid>
              {file && (
                <Grid
                  style={{
                    textAlign: 'left',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <IconButton
                    aria-label="close"
                    style={{ marginLeft: 'auto' }}
                    onClick={handleRemoveFile}
                  >
                    <Icon path={mdiClose} size={1} />
                  </IconButton>
                  <span style={{ marginTop: '14px' }}>
                    <span style={{ fontWeight: 'bold' }}> {file.name} </span>
                    <span>( {file.size} KB )</span>
                  </span>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={1}
                direction="row-reverse"
                style={{ marginBottom: '8px' }}
              >
                <Grid item>
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    color="primary"
                    style={{ marginLeft: '24px' }}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress style={{ height: "30px", width: "30px" }} /> : `ارسال پیام`}
                  </Button>
                </Grid>

                {handleCloseModal ? (
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      color="default"
                      onClick={handleCloseModal}
                    >
                      {`بازگشت`}
                    </Button>
                  </Grid>
                ) : null}
              </Grid>
            </DialogActions>
          </form>
        </Grid>
      </Dialog>
      <Modal
        onClose={() => setOpenInventoryItems(false)}
        maxWidth="md"
        open={openInventoryItems}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiStoreOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={<InventoryItemsList data={props.inventoryItems} />}
      />
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  catList: makeSelectCatList(),
  order: makeSelectOrder(),
  orderItems: makeSelectAllOrderItems(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsWithSerialList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getCatDispatch: (payload: any) => dispatch(getCatAction(payload)),
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateOrderStatusActions(payload)),
    clearOrderActionDispatch: () => dispatch(clearOrderAction()),
    getInventoryItems: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
    getOrderItemsActionDispatch: (payload: any) =>
      dispatch(getAllOrderItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
